import { atomWithStorage } from 'jotai/utils'

export const AUTH_PROVIDER_LOCAL_STORAGE_KEY = 'auth_provider'

const AuthProviderType = {
  COGNITO: 'COGNITO',
  AUTH0: 'AUTH0'
} as const
export type AuthProviderType = keyof typeof AuthProviderType

/**
 * 認証プロバイダー (Cognito or Auth0) を管理する atom
 * ローカルストレージに保存される
 */
export const authProviderAtom = atomWithStorage<AuthProviderType | null>(
  AUTH_PROVIDER_LOCAL_STORAGE_KEY,
  null,
  undefined,
  {
    getOnInit: true
  }
)

authProviderAtom.debugLabel = 'authProviderAtom'
